import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import { InputLabel, TextField } from '@mui/material';
import { API_URL } from '../../Constants';

let apiUrl = API_URL;

function RequestStatus() {

    const [data, setData] = useState([]);
    const [commerceName, setCommerceName] = useState('');

    useEffect(() => {
        if (localStorage.getItem('commerceUuid') == null) {
            window.location = '/';
        }

        fetch(apiUrl + '/v1/feasibility-inquiries/commerce/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setData(res.content);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });

        fetch(apiUrl + '/v1/commerces/' + localStorage.getItem('commerceUuid'), {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setCommerceName(res.name);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });


    }, [])

    const handleQuotaSimulator = (clientUuid) => {
        localStorage.setItem("clientUuid", clientUuid);
        window.location = '/quota-simulator';
    }

    const handleLogOut = () => {
        localStorage.clear();
        window.location = '/commerce-loggin';
    }

    const handleFeasibility = () => {
        window.location = '/feasibility';
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <Container maxWidth="md">
                <br />
                <h1>Viabilidades pendientes - {commerceName}</h1>
                <br />
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Name</TableCell>
                                <TableCell align="center">Document</TableCell>
                                <TableCell align="center">Viability Status</TableCell>
                                <TableCell align="center"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow
                                    key={row.client.uuid}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell align="center">{row.client.name} {row.client.lastName}</TableCell>
                                    <TableCell align="center">{row.client.documentType} - {row.client.documentNumber}</TableCell>
                                    <TableCell align="center">{row.status}</TableCell>
                                    {row.status === "CONSULTED" ? <TableCell align="center">
                                        <Button variant="contained" endIcon={<SendIcon />} onClick={() => handleQuotaSimulator(row.client.uuid)}>
                                            Simulador de cuotas
                                        </Button>
                                    </TableCell> : null}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <br />
                <Button variant="contained" endIcon={<SendIcon />} onClick={handleFeasibility}>
                    Realizar consulta
                </Button>
                <br />
                <br />
                <Button variant="contained" endIcon={<SendIcon />} onClick={handleLogOut}>
                    Log out
                </Button>
            </Container>
        </React.Fragment>

    );
}

export default RequestStatus;